import { Box } from "@mantine/core";

import Flex from "components/Flex";

import { CarDiagram } from "./CarDiagram";
import { ImpactSelectors } from "./ImpactSelectors";
import { useStyles } from "./styles";

export const VehicleImpact = ({ editable = true }) => {
  const { classes } = useStyles({ editable });

  return (
    <Flex flex={1} align="center">
      <Box className={classes.carPictureContainer}>
        <ImpactSelectors editable={editable} />
        <CarDiagram alt="Top of car for selecting point of impact" className={classes.carPicture} />
      </Box>
    </Flex>
  );
};
